import { Component, OnInit } from '@angular/core';
import { HttpService } from '../http.service';
import { ValidationService } from '../validation.service';
import { SnackbarService } from '../snackbar.service';
import { Messages} from '../constants/messages';
import { Router } from '@angular/router';
export interface emailId {
  email_id: String;
}

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})


export class ForgotPasswordComponent implements OnInit {

  email: emailId = {
    email_id: ''
  };
  messages = new Messages();

  constructor(private http: HttpService, private valid: ValidationService, private snackbar: SnackbarService,
              private route: Router) { }

  ngOnInit() {
  }

  submit() {
    if (!(this.valid.isEmpty(this.email.email_id)) && (this.valid.isEmail(this.email.email_id))) {
      this.http.post('carrier_user/password/forgot', this.email).subscribe(
        (data: any) => {
          if (data.statusCode === 200) {
            this.snackbar.openSnackBar(this.messages.FORGOT_PASSWORD.SUCCESS.RESET_LINK, '');
            this.route.navigateByUrl('login');
          }
        },
        (err: any) => {
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        }
      );
    } else {
      this.snackbar.openSnackBar(this.messages.FORGOT_PASSWORD.ERROR.EMAIL_ID, '', 'err');
    }
  }
}
